<template>
  <b-modal
    size="xl"
    id="resumeclinicmodal"
    hide-footer
    hide-header
    v-model="openresumeclinicModal"
    :centered="!isMobile"
    no-close-on-backdrop
    no-enforce-focus
  >
    <template v-if="secondmodal == true && firstmodal == false">
      <section
        class="w-100 d-flex flex-column align-items-center justify-content-center h-100"
      >
        <div style="height: 85px"></div>
        <div v-if="loaderStatus">
          <Spinner :id="'resumeclinic'" />
        </div>
      </section>
    </template>
    <template v-if="!firstmodal && !secondmodal">
      <section class="p-3 mob-txt-center">
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="color-2E425D fw-700 font-manrope fs-18 mob-w100">
            Resume Clinic
          </h5>

          <img
            src="@/assets/imgs/Builderpage/onboarding/modal-close.svg"
            class="pointer rotate-on-hover"
            alt="Hire3x modal close icon"
            @click="modalClose()"
            id="hideinmobile"
          />
          <img
            src="@/assets/imgs/resumeclinic/mobclose.svg"
            class="mobilecloseicon pointer rotate-on-hover"
            alt="Hire3x modal close icon"
            @click="modalClose()"
            id="hideinlaptop"
          />
        </div>
        <h6 class="color-7a7a7a fs-14 fw-500 font-sans-pro mt-2">
          Get AI-driven insights and tailor your resume to match job
          descriptions for better ATS compatibility.
        </h6>
      </section>
      <hr class="rc-hr mt-0" id="hideinmobile" />
      <section
        class="p-3 d-flex justify-content-center flex-column mob-justify-unset align-items-center w-100 template-height"
      >
        <div
          class="d-flex w-100 gap-3 mob-d-block"
          :class="{ 'justify-content-center': !jdchecked }"
        >
          <div
            class="w-50 mob-w100"
            :class="{
              'uplod-error-box': errorMessage,
              'rotating-border': !errorMessage && !fileName,
              'uploaded-green-border': fileName && !errorMessage,
            }"
          >
            <div
              class="card-content d-flex flex-column align-items-center position-relative"
            >
              <img
                v-if="fileName"
                src="../../assets/imgs/resumeclinic/uploadedresume.svg"
                alt="Hire3x uploaded resume icon"
              />
              <img
                v-else
                src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/ResumeClinic/ResumeClinic-dp.svg"
                alt="Hire3x upload resume icon"
              />
              <span
                v-if="!fileName"
                class="font-inter fs-16 mob-fs-14 fw-600 color-595959 w-75 my-3 mob-txt-center"
              >
                Click on upload your resume button to get started</span
              >
              <template v-if="fileName">
                <div
                  class="w-75 mb-3 mt-4 fileinputcontainer d-flex justify-content-between align-items-center"
                >
                  <div>
                    <img
                      src="../../assets/imgs/resumeclinic/file.svg"
                      alt="Hire3x resumeclinic file icon"
                    />
                  </div>
                  <div
                    class="fs-18 fw-700 font-lato color-darkblue px-2 text-truncate"
                  >
                    {{ fileName }}
                  </div>
                  <div class="d-flex gap-2 align-items-center">
                    <div class="position-relative">
                      <img
                        @click="triggerFileInput"
                        class="pointer"
                        src="../../assets/imgs/resumeclinic/replace.svg"
                        alt="Hire3x Replace File"
                      />
                      <input
                        class="rs-d-none"
                        type="file"
                        ref="fileInput"
                        @change="handleFileUpload"
                        accept=".pdf, .docx"
                      />
                    </div>
                    <img
                      src="../../assets/imgs/resumeclinic/line.svg"
                      alt="Hire3x line"
                    />
                    <img
                      @click="deleteFile"
                      class="pointer"
                      src="../../assets/imgs/resumeclinic/delete.svg"
                      alt="Hire3x delete icon"
                    />
                  </div>
                </div>
              </template>
              <p
                v-if="errorMessage"
                class="color-red fw-500 mob-fs-12 fs-14 mb-4"
              >
                {{ errorMessage }}
              </p>
              <span
                v-else
                class="fw-500 mob-fs-12 fs-14 color-595959 style-italic mb-4"
                >PDF & DOCX only, Max file size is 10 MB</span
              >
              <template v-if="!fileName">
                <div class="primary-bluebtn resume-upload-btn">
                  <b-button variant="primary" class="" @click="triggerFileInput"
                    >Upload Your Resume</b-button
                  >
                </div>
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileUpload"
                  accept=".pdf,.docx"
                  class="rs-d-none"
                />
              </template>
            </div>
          </div>
          <div class="w-50 mob-w100" v-if="jdchecked">
            <div class="resumeclinic-inputs mob-mt30px">
              <label class="color-2E425D fs-14 fw-700 font-sans-pro"
                >Job Role</label
              >
              <b-form-input
                v-model="jobRole"
                placeholder="Please enter your job title here"
              ></b-form-input>
            </div>
            <div class="resumeclinic-textarea mt-3">
              <label class="color-2E425D fs-14 fw-700 font-sans-pro"
                >Job Description</label
              >
              <b-form-textarea
                v-model="jobDescription"
                placeholder="Enter the description..."
                rows="5"
                max-rows="6"
              ></b-form-textarea>
            </div>
          </div>
        </div>
        <div
          class="mt-5 mob-w100 rc-compare-container position-relative d-flex align-items-center justify-content-center"
        >
          <b-form-checkbox
            v-model="jdchecked"
            name="check-button"
            switch
            class="pointer"
          >
          </b-form-checkbox>

          <div class="ml-2">
            <h5 class="fs-16 mob-fs-14 fw-700 font-manrope color-mainblue">
              Compare with job description
            </h5>
            <h6
              class="fs-14 fw-400 mob-fs-12 font-sans-pro color-darkblack mobmt-15px"
            >
              Get targeted insights against Job description with our AI checker
            </h6>
          </div>
          <img
            src="../../assets/imgs/resumeclinic/star.svg"
            class="position-absolute top-0 right-0"
            alt="Hire3x validation icon"
          />
        </div>
      </section>
      <hr class="rc-hr mt-3 mb-0" />
      <footer
        class="primary-bluebtn p-3 d-flex align-items-center justify-content-end"
      >
        <b-button
          variant="primary"
          class="w-250px mob-w100"
          @click="uploadresume"
          :disabled="fileName == ''"
          >Continue</b-button
        >
      </footer>
    </template>
    <template v-if="firstmodal == true && secondmodal == false">
      <section class="p-3 mob-txt-center">
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="color-2E425D fw-700 font-manrope fs-18 mob-w100">
            Your results
          </h5>

          <img
            src="@/assets/imgs/Builderpage/onboarding/modal-close.svg"
            class="pointer rotate-on-hover"
            alt="Hire3x modal close icon"
            @click="modalClose()"
            id="hideinmobile"
          />

          <img
            src="@/assets/imgs/resumeclinic/mobclose.svg"
            class="mobilecloseicon pointer rotate-on-hover"
            alt="Hire3x modal close icon"
            @click="modalClose()"
            id="hideinlaptop"
          />
        </div>
        <h6 class="color-7a7a7a fs-14 fw-500 font-sans-pro mt-2">
          Check out the insights generated from your resume.
        </h6>
      </section>
      <hr class="rc-hr mt-0" id="hideinmobile" />
      <section
        class="d-flex justify-content-center flex-column align-items-center w-100"
      >
        <div class="template3-height mobh-unset d-flex w-100 gap-3 mob-d-block">
          <div class="w-30 mob-w100 p-3 h-100 tabh-unset overflow-auto">
            <div
              class="rc-result-left-top pt-3 d-flex mobflexrow flex-column justify-content-center align-items-center"
            >
              <div class="mobpl2 text-center">
                <h5 class="fs-16 fw-500 font-sans-pro color-white">
                  Your Resume Score:
                </h5>
                <h3
                  class="mt-2 fs-24 fw-800 font-manrope color-F9C82B text-uppercase"
                >
                  {{ overAllRating }}
                </h3>
              </div>
              <div class="text-center position-relative mt-3 mobmt-0">
                <img
                  src="../../assets/imgs/resumeclinic/resumemeter.svg"
                  alt="Hire3x resumeclinic score meter"
                />
                <img
                  class="position-absolute"
                  src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/website/blackDial.svg"
                  alt="Hire3x resumemeter pointer"
                  :class="getMeterClass"
                />
                <!--   :class="getMeterClass" -->
              </div>
            </div>
            <div class="" id="hideinmobile">
              <div
                v-for="([key, value], index) in sortedCandidateData"
                :key="index"
              >
                <div
                  v-if="
                    key !== 'uuid' &&
                    key !== 'overall' &&
                    key !== 'resume_vs_job' &&
                    key !== 'candidate_name' &&
                    key !== 'candidate_email'
                  "
                  class="mt-3 rc-result-top-cards d-flex align-items-center justify-content-between pointer"
                  @click="scrollToAccordion(index)"
                >
                  <div class="d-flex align-items-center">
                    <div
                      class="rc-res-left-card-boxes"
                      :class="{
                        'bg-boxgreen': value.rating == 1,
                        'bg-boxyellow': value.rating == 2,
                        'bg-boxorange': value.rating == 3,
                        'bg-boxred': value.rating == 4,
                      }"
                    ></div>
                    <div
                      class="ml-2 pt-1 fs-14 fw-500 font-sans-pro color-darkblack text-capitalize"
                    >
                      <span v-if="key === 'personal_info'"> Personal Info</span>
                      <span v-else> {{ key }}</span>
                    </div>
                  </div>
                  <div class="d-flex gap-3 align-items-center">
                    <div
                      class="rc-reviewtag fs-12 fw-500 font-sans-pro"
                      v-if="value.rating !== 1"
                    >
                      Review
                    </div>
                    <img
                      src="../../assets/imgs/resumeclinic/rightarw.svg"
                      alt="Hire3x Forward Arrow"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="w-70 pr-3 mobp-3 h-100 overflow-xh-ya mob-w100 mobh-unset mr-1"
          >
            <section class="rc-result-right-top">
              <h3 class="fw-700 font-mont fs-16 color-white">
                {{ candidateData.payload.overall.suggestions }}
                <!-- We parsed only <span class="fw-800 color-ad1927"> 52% </span>of
                your resume successfully using an industry-leading ATS. -->
              </h3>
              <div
                class="rc-rrt-subbars my-3 font-mont fw-500 fs-14 style-italic"
              >
                Key findings:-
              </div>
              <b-row>
                <b-col cols="12" md="4" class="mb-3">
                  <div class="info-card">
                    <img
                      v-if="candidateData.payload.overall.relavent_experience"
                      src="@/assets/imgs/resumeclinic/greentick.svg"
                      alt="Hire3x Resumeclinic - Greentick"
                    />
                    <img
                      v-else
                      src="@/assets/imgs/resumeclinic/redcross.svg"
                      alt="Hire3x Resumeclinic - RedXmark"
                    />
                    <span
                      class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
                      >Relevance of Experience</span
                    >
                  </div>
                </b-col>

                <b-col cols="12" md="4" class="mb-3">
                  <div class="info-card">
                    <img
                      v-if="
                        candidateData.payload.overall
                          .relavent_career_progression
                      "
                      src="@/assets/imgs/resumeclinic/greentick.svg"
                      alt="Hire3x Resumeclinic - Greentick"
                    />
                    <img
                      v-else
                      src="@/assets/imgs/resumeclinic/redcross.svg"
                      alt="Hire3x Resumeclinic - REDXmark"
                    />
                    <span
                      class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
                      >Career Progression</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="4" class="mb-3">
                  <div class="info-card">
                    <img
                      v-if="candidateData.payload.overall.relavent_education"
                      src="@/assets/imgs/resumeclinic/greentick.svg"
                      alt="Hire3x Resumeclinic - Greentick"
                    />
                    <img
                      v-else
                      src="@/assets/imgs/resumeclinic/redcross.svg"
                      alt="Hire3x Resumeclinic - REDXmark"
                    />
                    <span
                      class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
                      >Educational Relevance</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="4" class="mb-3">
                  <div class="info-card">
                    <img
                      v-if="
                        candidateData.payload.overall
                          .relavent_industry_or_domain
                      "
                      src="@/assets/imgs/resumeclinic/greentick.svg"
                      alt="Hire3x Resumeclinic - Greentick"
                    />
                    <img
                      v-else
                      src="@/assets/imgs/resumeclinic/redcross.svg"
                      alt="Hire3x Resumeclinic - RedXmark"
                    />
                    <span
                      class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
                      >Industry Knowledge</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="4" class="mb-3">
                  <div class="info-card">
                    <img
                      v-if="candidateData.payload.overall.relavent_skill"
                      src="@/assets/imgs/resumeclinic/greentick.svg"
                      alt="Hire3x Resumeclinic - Greentick"
                    />
                    <img
                      v-else
                      src="@/assets/imgs/resumeclinic/redcross.svg"
                      alt="Hire3x Resumeclinic - REDXmark"
                    />
                    <span
                      class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
                      >Skills in Experience
                    </span>
                  </div>
                </b-col>
              </b-row>
              <div
                v-if="suggestedJobs.length != 0"
                class="rc-rrt-subbars my-3 font-mont fw-500 fs-14 style-italic"
              >
                Suggested Job roles:-
              </div>
              <article
                class="rc-ref-jobscontainer d-flex flex-wrap gap-3 pl-1 align-items-center"
                ref="jobsContainer"
                v-if="suggestedJobs.length != 0"
              >
                <div
                  v-for="(job, index) in suggestedJobs"
                  :key="index"
                  class="rc-suggested-tags fs-14 fw-400 font-mont color-white"
                >
                  {{ job.title }}
                  <img
                    class="ml-2 pointer"
                    @click="
                      openLoginModalWithJobID(
                        job.jobID,
                        candidateData.payload.uuid,
                      )
                    "
                    src="../../assets/imgs/resumeclinic/overview.svg"
                    alt="Hire3x Resumeclinic - Overview icon"
                  />
                </div>
                <div
                  class="font-lato fw-700 fs-14 color-white pointer"
                  v-if="viewMore"
                >
                  <span
                    class="text-underline mr-1"
                    @click="openLoginAndGoToJobs()"
                    >+{{
                      suggestedCopy.length - suggestedJobs.length
                    }}
                    more</span
                  >
                  <!-- <img
                    src="../../assets/imgs/resumeclinic/downarw.svg"
                    alt=""
                  /> -->
                </div>
              </article>
              <!-- <article class="d-flex flex-wrap gap-3 align-items-center" v-else>
                <div
                  v-for="(job, index) in suggestedCopy"
                  :key="index"
                  class="rc-suggested-tags fs-14 fw-400 font-mont color-white"
                >
                  {{ job.title }}
                  <img
                    @click="gotologinpage(candidateData.payload.uuid)"
                    class="ml-2 pointer"
                    src="../../assets/imgs/resumeclinic/overview.svg"
                    alt=""
                  />
                </div>
                <div class="font-lato fw-700 fs-14 color-white pointer">
                  <span class="text-underline mr-1" @click="showAll = false"
                    >Show less</span
                  >
                  <img
                    src="../../assets/imgs/resumeclinic/downarw.svg"
                    alt=""
                  />
                </div>
              </article> -->
            </section>

            <section class="mt-3">
              <div class="accordioncards" role="tablist">
                <b-card
                  no-body
                  class="mb-2 pointer"
                  v-for="([key, value], index) in sortedCandidateData"
                  :key="index"
                  :ref="'accordion-' + index"
                  :class="
                    key !== 'overall' &&
                    key !== 'uuid' &&
                    key !== 'resume_vs_job' &&
                    key !== 'candidate_name' &&
                    key !== 'candidate_email'
                      ? ''
                      : 'noborder'
                  "
                  @click="toggleAccordion(index)"
                >
                  <b-card-header
                    v-if="
                      key !== 'overall' &&
                      key !== 'uuid' &&
                      key !== 'resume_vs_job' &&
                      key !== 'candidate_name' &&
                      key !== 'candidate_email'
                    "
                    header-tag="header"
                    class="d-flex align-items-center justify-content-between"
                    role="tab"
                  >
                    <div
                      class="text-capitalize fam-mont fs-16 fw-M color-2E425D"
                    >
                      <img
                        v-if="imageMap[key]"
                        :src="imageMap[key]"
                        alt="Hire3x resumeclinic attributes icon"
                      />

                      <span v-if="key === 'personal_info'"> Personal Info</span>
                      <span v-else> {{ key }}</span>
                    </div>
                    <div class="d-flex align-items-center gap-3">
                      <div
                        class="parsedtagsize"
                        :class="{
                          fairtag: value.rating == 4,
                          goodtag: value.rating == 2,
                          okaytag: value.rating == 3,
                          amzngtag: value.rating == 1,
                        }"
                      >
                        <span v-if="value.rating == 1">AMAZING</span>
                        <span v-if="value.rating == 2">GOOD</span>
                        <span v-if="value.rating == 3">OKAY</span>
                        <span v-if="value.rating == 4">FAIR</span>
                      </div>
                      <img
                        v-if="!activeAccordion[index]"
                        :id="'toggle-btn-' + index"
                        src="@/assets/imgs/resumeclinic/bluedownarw.svg"
                        alt="Hire3x card clickable arrow"
                        class="pointer"
                      />
                      <img
                        v-else
                        :id="'toggle-btn-' + index"
                        src="@/assets/imgs/resumeclinic/blueuparw.svg"
                        alt="Hire3x card clickable arrow"
                        class="pointer"
                      />
                    </div>
                  </b-card-header>

                  <b-collapse
                    :id="'accordion-' + index"
                    v-model="activeAccordion[index]"
                    accordion="my-accordion"
                    role="tabpanel"
                    :class="
                      (key === 'projects' ||
                        key === 'skills' ||
                        key === 'endeavours') &&
                      !isLoggedIn
                        ? 'blurbackground'
                        : ''
                    "
                  >
                    <b-card-body class="position-relative">
                      <b-card-text v-if="value.suggestions">
                        {{ value.suggestions }}
                      </b-card-text>
                      <b-card-text v-else>
                        No suggestions available.
                      </b-card-text>
                      <div class="unlockbtn primary-bluebtn position-absolute">
                        <b-button
                          variant="primary"
                          v-if="
                            (key === 'projects' ||
                              key === 'skills' ||
                              key === 'endeavours') &&
                            !isLoggedIn
                          "
                          @click="openLoginModal(candidateData.payload.uuid)"
                        >
                          <img
                            src="../../assets/imgs/resumeclinic/lock.svg"
                            alt="Hire3x resumeclinic attribute lock icon"
                          />
                          Unlock now</b-button
                        >
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </section>
            <section class="mt-3" v-if="visibleCards.length != 0">
              <h5 class="fw-700 fs-16 font-manrope color-black">
                Check out job listings for you
              </h5>
              <div
                class="d-flex gap-3 moboverflowx-auto joblistingcards overflow-auto job w-100 mt-3"
                ref="jobscrollContainer"
              >
                <div class="d-flex gap-3 w-100" :key="currentIndex">
                  <b-card v-for="(item, index) in visibleCards" :key="index">
                    <h5
                      :id="'jobtitle-' + index"
                      v-b-tooltip.hover="{ title: tooltipMap['title-' + index] || '', disabled: !tooltipMap['title-' + index] }"
                      class="color-2E425D font-marope fw-600 fs-16 text-truncate"
                      @mouseenter="checkAndShowTooltip($event.currentTarget, item.title, 'title-' + index, 'jobtitle-' + index)"
                    >{{ item.title }}</h5>
                    <h6
                      :id="'jobname-' + index"
                      v-b-tooltip.hover="{ title: tooltipMap['name-' + index] || '', disabled: !tooltipMap['name-' + index] }"
                      class="color-3a3c40 fw-500 fs-14 font-mont my-2 text-truncate"
                      @mouseenter="checkAndShowTooltip($event.currentTarget, item.customerName, 'name-' + index, 'jobname-' + index)"
                    >{{ item.customerName }}</h6>

                    <p
                      class="m-0 p-0 color-7a7a7a fs-12 fw-500 font-mont d-flex align-items-center"
                    >
                      <img
                        class="mr-1"
                        src="../../assets/imgs/resumeclinic/location.svg"
                        alt="Hire3x Location Icon"
                      />
                      <span
                        v-for="index in Math.min(item.location.length, 2)"
                        :key="index"
                        class="text-capitalize"
                      >
                        {{ item.location[index - 1] }}
                        <span
                          v-if="index === Math.min(item.location.length, 2) - 1"
                          >,&nbsp;</span
                        >
                      </span>
                      <template v-if="item.location.length > 2">
                        &nbsp; +{{ item.location.length - 2 }}&nbsp;More
                      </template>
                      <template v-if="item.location.length == 0"> -- </template>
                    </p>
                    <div
                      class="d-flex align-items-center gap-2 mt-3"
                      :class="{
                        'justify-content-between':
                          item.experienceRequired === '',
                      }"
                    >
                      <div
                        :class="item.experienceRequired !== '' ? 'w-40' : ''"
                        class="d-flex align-items-center joblistingcard-tags fw-500 fs-12 font-mont color-white"
                      >
                        <img
                          class="mr-1"
                          src="../../assets/imgs/resumeclinic/time.svg"
                          alt="Hire3x Time icon"
                        />
                        <span class="text-truncate text-capitalize">
                          {{ item.jobType }}</span
                        >
                      </div>
                      <div
                        v-if="item.experienceRequired !== ''"
                        class="d-flex align-items-center joblistingcard-tags fw-500 fs-12 font-mont color-white w-45"
                      >
                        <img
                          class="mr-1"
                          src="../../assets/imgs/resumeclinic/user.svg"
                          alt="Hire3x User icon"
                        />

                        <template v-if="item.experienceRequired == 'others'"
                          >12+ Years</template
                        >
                        <template v-else>
                          {{ item.experienceRequired }} Years</template
                        >
                      </div>
                      <img
                        id="hideinmobile"
                        @click="
                          openLoginModalWithJobID(
                            item.jobID,
                            candidateData.payload.uuid,
                          )
                        "
                        class="pointer"
                        src="../../assets/imgs/resumeclinic/blueforward.svg"
                        alt="Hire3x Forward Arrow"
                      />
                    </div>
                    <hr id="hideinlaptop" class="mb-2" />
                    <div
                      class="d-flex align-items-center justify-content-center fs-12 fw-600 font-mont color-376FAA"
                      id="hideinlaptop"
                    >
                      Apply
                      <img
                        @click="
                          openLoginModalWithJobID(
                            item.jobID,
                            candidateData.payload.uuid,
                          )
                        "
                        class="pointer"
                        src="../../assets/imgs/resumeclinic/blueforward.svg"
                        alt="Hire3x Forward Arrow"
                      />
                    </div>
                  </b-card>
                </div>
              </div>
              <HorizontalSlider
                v-if="sliderReady"
                :scrollContainerRef="scrollContainerRef"
                scrollContainerId="scrollContainer3"
              />
            </section>
          </div>
        </div>
      </section>
      <hr class="rc-hr mt-3 mb-0" />
      <footer class="p-3 d-flex align-items-center gap-3 justify-content-end">
        <div
          class="builder-outline-btns mob-w50"
          :class="{ 'btn-loading': buttonLoader }"
        >
          <div v-if="buttonLoader" class="loader-pos-new">
            <BlueLoader />
          </div>
          <b-button
            variant="outline-secondary"
            class="mob-w100 w-200px"
            :disabled="buttonLoader"
            @click="triggerDownloadReport(candidateData.payload.uuid)"
          >
            <img
              v-if="!buttonLoader"
              src="../../assets/imgs/resumeclinic/downloadicon.svg"
              class="mr-2"
              id="hideinmobile"
              alt="Hire3x download icon"
            />
            {{ buttonLoader ? "" : "Download Report" }}
          </b-button>
        </div>
        <div v-if="isLoggedIn && getAccess('candidate')" class="primary-bluebtn mob-w50">
          <b-button
            variant="primary"
            class="w-250px mob-w100"
            @click="
              (firstmodal = false), (secondmodal = false), (fileName = '')
            "
          >
            <img
              id="hideinmobile"
              src="../../assets/imgs/resumeclinic/uploadicon.svg"
              class="mr-2"
              alt="Hire3x Upload Icon"
            />
            Upload Resume</b-button
          >
        </div>
      </footer>
    </template>
  </b-modal>
</template>

<script>
import EventBus from "@/utils/eventBus";
import { resumeClinic, suggestedJobs, converter } from "@/utils/apiFunction";
import "@/assets/css/builderpage.css";
import Spinner from "@/components/fixedComponents/Spinner.vue";
import HorizontalSlider from "../fixedComponents/HorizontalSlider.vue";
import config from "@/utils/config";
import { mapGetters } from "vuex";
import { clearAllCookiesExceptGuest, getAccess, openLoginModal } from "@/utils/helpers";
import BlueLoader from "../fixedComponents/BlueLoader.vue";
import successModal from "@/utils/mixins/toast.js";
export default {
  data() {
    return {
      sliding: null,
      scrollContainerRef: null,
      sliderReady: false,
      showAll: false,
      viewMore: true,
      suggestedCopy: [],
      firstmodal: false,
      secondmodal: false,
      fileData: {},
      fileName: "",
      resumeData: {},
      keyStates: {},
      loaderStatus: false,
      buttonLoader: false,
      resumeUpLoaded: false,
      reportPayload: {},
      jobRole: "",
      jobDescription: "",
      checked: false,
      numberofcards: 10,
      itemsPerPage: 3,
      isMobile: false,
      openresumeclinicModal: this.showModal,
      jdchecked: false,
      candidateData: {},
      currentIndex: 0,
      tooltipMap: {},
      keyfindings: [
        { name: "Career Progression" },
        { name: "Educational Relevance" },
        { name: "Relevance of Experience" },
        { name: "Industry Knowledge" },
        { name: "Gaps in Experience" },
        // { name: "Cultural Fit" },
      ],
      imageMap: {
        resume_vs_job: require("../../assets/imgs/resumeclinic/resjdicon.svg"),
        personal_info: require("../../assets/imgs/resumeclinic/personalinfo.svg"),
        education: require("../../assets/imgs/resumeclinic/education.svg"),
        experience: require("../../assets/imgs/resumeclinic/expereince.svg"),
        projects: require("../../assets/imgs/resumeclinic/projects.svg"),
        portfolio: require("../../assets/imgs/resumeclinic/portfolio.svg"),
        skills: require("../../assets/imgs/resumeclinic/skills.svg"),
        endeavours: require("../../assets/imgs/resumeclinic/edev.svg"),
        template: require("../../assets/imgs/resumeclinic/template.svg"),
      },
      suggestedJobs: [],
      displayCount: 3,
      slideDirection: "slide-right",
      activeAccordion: {},
      scoreColor: {
        red: "Fair",
        green: "Amazing",
        yellow: "Good",
        orange: "Okay",
      },
      overallScore: null,
      errorMessage: "",
    };
  },
  props: {
    showModal: {
      type: Boolean,
    },
  },
  mixins: [successModal],
  components: {
    Spinner,
    HorizontalSlider,
    BlueLoader,
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
    EventBus.$off("mobile-menu-state", this.closingModal);
    EventBus.$off("header-search-state", this.closingModal);
    EventBus.$off("logo-clicked", this.onLogoClicked);
    EventBus.$off("close-resume-clinic", this.onCloseEvent);
    EventBus.$emit("resume-clinic-closed");
    this.removeRedirectQuery();
  },
  mounted() {
    this.closingModal = (state) => {
      if (state && this.openresumeclinicModal) {
        this.modalClose();
      }
    };
    this.onLogoClicked = () => {
      if (this.openresumeclinicModal) {
        this.modalClose();
      }
    };
    this.onCloseEvent = () => {
      if (this.openresumeclinicModal) {
        this.modalClose();
      }
    };
    EventBus.$on("mobile-menu-state", this.closingModal);
    EventBus.$on("header-search-state", this.closingModal);
    EventBus.$on("logo-clicked", this.onLogoClicked);
    EventBus.$on("close-resume-clinic", this.onCloseEvent);

    console.log("HorizontalSlider mounted with:", this.scrollContainerRef);
    this.checkScreenWidth();
  },

  updated() {
    if (!this.sliderReady && this.visibleCards.length) {
      this.$nextTick(() => {
        const container = this.$refs.jobscrollContainer;
        if (container) {
          this.scrollContainerRef = container;
          this.sliderReady = true;
        }
      });
    }
  },
  watch: {
    suggestedCopy() {
      this.sliderReady = false;
    },
    openresumeclinicModal: {
      immediate: true,
      handler(val) {
        if (val) {
          EventBus.$emit("resume-clinic-opened");
        } else {
          EventBus.$emit("resume-clinic-closed");
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "userVUEX/getCandAccess",
    }),
    sortedCandidateData() {
      const order = [
        "personal_info",
        "education",
        "projects",
        "portfolio",
        "skills",
        "experience",
        "endeavours",
      ];

      return Object.entries(this.candidateData.payload)
        .filter(
          ([key]) =>
            key !== "uuid" && key !== "overall" && key !== "resume_vs_job",
        )
        .sort((a, b) => order.indexOf(a[0]) - order.indexOf(b[0]));
    },
    groupedCards() {
      const groupSize = 3;
      const grouped = [];
      const cardData = this.suggestedCopy.slice(0, 12);
      for (let i = 0; i < cardData.length; i += groupSize) {
        grouped.push(cardData.slice(i, i + groupSize));
      }
      return grouped;
    },
    visibleCards() {
      const limitedJobs = this.suggestedCopy.slice(0, 12);
      return limitedJobs;
    },
    isRightArrowDisabled() {
      return (
        this.currentIndex + this.itemsPerPage >=
        Math.min(this.suggestedCopy.length, 12)
      );
    },
    overAllRating() {
      if (this.overallScore === 1) {
        return "Amazing";
      } else if (this.overallScore === 2) {
        return "Good";
      } else if (this.overallScore === 3) {
        return "Okay";
      } else {
        return "Fair";
      }
    },
    getMeterClass() {
      const score = parseInt(this.overallScore);
      switch (score) {
        case 1:
          return "amzing-dial";
        case 2:
          return "good-dial";
        case 3:
          return "okay-dial";
        case 4:
          return "fair-dial";
        default:
          return "dial-rating-zero";
      }
    },
  },
  methods: {
    getAccess(access){
      return getAccess(access)
    },
    checkAndShowTooltip(el, text, mapKey, elId) {
      if (el && el.scrollWidth > el.offsetWidth) {
        this.$set(this.tooltipMap, mapKey, text);
        this.$nextTick(() => {
          this.$root.$emit('bv::show::tooltip', elId);
        });
      } else {
        this.$set(this.tooltipMap, mapKey, null);
      }
    },
    loadMore() {
      if (this.currentIndex + this.itemsPerPage < this.suggestedCopy.length) {
        this.slideDirection = "slide-right";
        this.currentIndex += this.itemsPerPage;
      }
    },
    loadLess() {
      if (this.currentIndex > 0) {
        this.slideDirection = "slide-left";
        this.currentIndex -= this.itemsPerPage;
      }
    },
    async downloadHTML() {
      try {
        this.loaderStatus = true;
        this.buttonLoader = true;
        const res = await converter(this.reportPayload);
        if (res.status === 200) {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/pdf" }),
          );

          // window.open(url);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Hire3x Report.pdf";
          link.click();
          // window.open(res.data.link);
          console.log(res, "parsed");
          this.loaderStatus = false;
          this.buttonLoader = false;
          this.successModal(
            "Successfully downloaded.",
            "The report was downloaded successfully.",
          );
        } else {
          this.loaderStatus = false;
          console.error("Error:", res);
        }
      } catch (error) {
        this.loaderStatus = false;
        this.buttonLoader = false;
        console.error("Failed to convert HTML:", error);
      }
    },
    checkScreenWidth() {
      this.isMobile = window.innerWidth <= 600; // For mobile and tablet (screen width <= 1028px)
    },
    triggerFileInput() {
      // Trigger the file input click event programmatically
      this.$refs.fileInput.click();
    },
    modalClose() {
      this.openresumeclinicModal = false;
      this.$bvModal.hide("resumeclinicmodal");
      this.$emit("modalClose");
      this.firstmodal = false;
      this.secondmodal = false;
      this.loaderStatus = false;
    },
    scrollToAccordion(index) {
      // Get the target accordion element
      const target = this.$refs[`accordion-${index}`]?.[0];
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        this.toggleAccordion(index);
      }
    },
    toggleAccordion(index) {
      // Open the accordion when clicking on the left-side item
      this.$set(this.activeAccordion, index, !this.activeAccordion[index]);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];

      if (file) {
        if (file.size > 10 * 1024 * 1024) {
          this.errorMessage =
            "File size exceeds 10MB. Please upload a smaller file.";
          this.fileData = null;
          this.fileName = "";
          return;
        }
        const allowedTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedTypes.includes(file.type)) {
          this.errorMessage =
            "Only PDF and Word documents (.pdf,.docx) are allowed.";
          this.fileData = null;
          this.fileName = "";
          return;
        }
        this.fileData = file;
        this.fileName = file.name;
        this.errorMessage = "";
      }
    },
    deleteFile() {
      this.fileName = "";
      this.fileData = null;
      this.$refs.fileInput.value = "";
    },

    async uploadresume() {
      this.secondmodal = true;
      this.loaderStatus = true;
      let form = new FormData();
      form.append("file", this.fileData);
      if (this.jdchecked) {
        form.append("role", this.jobRole);
        form.append("description", this.jobDescription);
      }

      try {
        const res = await resumeClinic(form);

        if (res.status === 200) {
          this.loaderStatus = true;
          this.candidateData = res.data;
          this.reportPayload = {
            payload: {
              ...res.data.payload,
              email: res.data.payload.candidate_email,
              name: res.data.payload.candidate_name,
            },
          };
          const jobPayload = {
            skills: this.candidateData.payload.overall.keywords,
            govtJobs: false,
            home: true,
          };
          const res2 = await suggestedJobs(jobPayload);
          setTimeout(() => {
            this.firstmodal = true;
            this.secondmodal = false;
          }, 500);
          if (res2.status === 200) {
            this.suggestedJobs = res2.data.data.data;
            this.overallScore = this.candidateData.payload.overall.rating;
            setTimeout(this.jobscrollCheck, 2000);
          }
        }
      } catch (error) {
        console.error("Error uploading resume:", error);
      }
    },

    async jobscrollCheck() {
      const temp = [...this.suggestedJobs];
      this.suggestedJobs = [];
      await this.$nextTick();
      let checkScroll = this.checkScroll();
      let index = 0;
      while (!checkScroll && index < temp.length) {
        this.suggestedJobs.push(temp[index++]);
        await this.$nextTick();
        checkScroll = this.checkScroll();
      }
      if (checkScroll) {
        this.suggestedJobs.pop();
      }
      this.viewMore = this.suggestedJobs.length < temp.length;
      await this.$nextTick();
      if (this.viewMore) {
        checkScroll = this.checkScroll();
        if (checkScroll) {
          this.suggestedJobs.pop();
        }
      }
      this.suggestedCopy = temp;
    },

    // async jobscrollCheck() {
    //   const temp = [...this.suggestedJobs];
    //   let checkScroll = this.checkScroll();

    //   while (checkScroll) {
    //     const data = [...this.suggestedJobs];
    //     let len = data.length;
    //     let half = Math.floor(len / 2);
    //     this.suggestedJobs.splice(0, half);
    //     await this.$nextTick();
    //     checkScroll = this.checkScroll();
    //   }
    //   for (let i = suggestedJobs.length; i <= 30; i++) {
    //     checkScroll = this.checkScroll();
    //     if (!checkScroll) {
    //       this.suggestedJobs.push(temp[i]);
    //     } else {
    //       this.suggestedJobs.pop();
    //       break;
    //     }
    //     await this.$nextTick();
    //   }
    //   this.viewMore = this.suggestedJobs.length < temp.length;
    //   await this.$nextTick();
    //   if (this.viewMore) {
    //     checkScroll = this.checkScroll();
    //     if (checkScroll) {
    //       this.suggestedJobs.pop();
    //     }
    //   }
    //   this.suggestedCopy = temp;
    // },

    checkScroll() {
      const jobContainer = this.$refs.jobsContainer;
      if (jobContainer?.scrollHeight > jobContainer?.clientHeight) {
        return true;
      } else {
        return false;
      }
    },

    // gotologinpage(uuid) {
    //   window.open(
    //     `https://simplifymycareer.com/login?uuid=${uuid}&resumeclinic=true`
    //   );
    // window.open(`http://localhost:8082/login?uuid=${uuid}&resumeclinic=true`);
    // window.open(`http://localhost:8081/login?uuid=${uuid}`);
    // },
    removeRedirectQuery() {
      if (this.$route.query.redirect) {
        const query = { ...this.$route.query };
        delete query.redirect;
        this.$router.replace({ query }).catch(() => {});
      }
    },
    gotoJobspage(jobid, uuid) {
      window.open(
        `${config.candidateBase}/builder/job/search?jobID=${jobid}&uuid=${uuid}&from=candidate`,
      );
      //  window.open(`http://localhost:8082/login?jobID=${jobid}&uuid=${uuid}`);
    },
    openLoginModal(uuid) {
      if (this.isLoggedIn) {
        this.downloadHTML();
      } else {
        this.$emit("openLoginModal", uuid);
      }
    },
    triggerDownloadReport(uuid){
      if(this.isLoggedIn && getAccess("candidate")) {
        this.downloadHTML();
      } else {
        this.$store.commit('userVUEX/setDownloadReport', true);
        this.$emit("openLoginModal", uuid);
      }
    },
    openLoginModalWithJobID(jobid, uuid) {
      if(this.isLoggedIn && getAccess("candidate")){
        this.removeRedirectQuery();
        this.$emit("openLoginModalWithJobID", jobid, uuid);
      }else {
        clearAllCookiesExceptGuest();
        this.$store.commit("userVUEX/setCandAccess", false)
        localStorage.clear();
        this.$emit("openLoginModalWithJobID", jobid, uuid);
      }
    },
    openLoginAndGoToJobs() {
      if(this.isLoggedIn && getAccess("candidate")){
        this.removeRedirectQuery();
      }
      openLoginModal({
        redirectUrl: `${config.candidateBase}/job/search?tab=hire&from=candidate`,
      });
    },
  },
};
</script>

<style>
.builder-outline-btns {
  position: relative;
}

.builder-outline-btns.btn-loading .btn {
  color: transparent;
}

.loader-pos-new {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.rc-hr {
  border-top: 1px solid #e4e7ec;
}

.rotating-border {
  position: relative;
  width: 100%;
  border-radius: 8px;
  background-size: 300% 300%;
  animation: rotate-gradient2 2s linear infinite; /* Rotate the gradient */
  padding: 3px; /* Space for the border */
}

/* Inner card content */
.card-content {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 13.9067px rgba(0, 0, 0, 0.07);
  border-radius: 14px;
  padding: 15px;
}

/* Animation for the gradient rotation */
@keyframes rotate-gradient2 {
  0% {
    background-position: 0% 5%;
    background: linear-gradient(0deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  5% {
    background-position: 5% 10%;
    background: linear-gradient(18deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  10% {
    background-position: 10% 15%;
    background: linear-gradient(36deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  15% {
    background-position: 15% 20%;
    background: linear-gradient(54deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  20% {
    background-position: 20% 25%;
    background: linear-gradient(72deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  25% {
    background-position: 25% 30%;
    background: linear-gradient(90deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  30% {
    background-position: 30% 35%;
    background: linear-gradient(108deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  35% {
    background-position: 35% 40%;
    background: linear-gradient(126deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  40% {
    background-position: 40% 45%;
    background: linear-gradient(144deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  45% {
    background-position: 45% 50%;
    background: linear-gradient(162deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  50% {
    background-position: 50% 55%;
    background: linear-gradient(180deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  55% {
    background-position: 55% 60%;
    background: linear-gradient(198deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  60% {
    background-position: 60% 65%;
    background: linear-gradient(216deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  65% {
    background-position: 65% 70%;
    background: linear-gradient(234deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  70% {
    background-position: 70% 75%;
    background: linear-gradient(252deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  75% {
    background-position: 75% 80%;
    background: linear-gradient(270deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  80% {
    background-position: 80% 85%;
    background: linear-gradient(288deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  85% {
    background-position: 85% 90%;
    background: linear-gradient(306deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  90% {
    background-position: 90% 95%;
    background: linear-gradient(324deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  95% {
    background-position: 95% 100%;
    background: linear-gradient(342deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  100% {
    background-position: 100% 0%;
    background: linear-gradient(360deg, #4A7EFF, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
}
.ml-6px {
  margin-left: 6px;
}
.pl-60 {
  padding-left: 60px;
}
/* rotating border end */

.rc-compare-container {
  padding: 12px 16px;
  background: #f0f4ff;
  border: 1px solid rgba(224, 224, 224, 0.3);
  border-radius: 8px;
}
.resumeclinic-inputs .form-control {
  height: 50px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 6px;
}
.resumeclinic-textarea .form-control {
  padding: 12px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 6px;
  min-height: 138px;
}
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #4A7EFF;
  border-color: #4A7EFF;
}
.rc-linealignment {
  position: relative;
  left: 14px;
  height: 50px;
}
.rc-result-left-top {
  background: linear-gradient(180deg, #7898c7 -100%, #091e34 100%);
  border-radius: 8px;
  overflow: hidden;
}
.color-F9C82B {
  color: #f9c82b;
}
.rc-result-top-cards {
  padding: 7px 12px;
  height: 40px;
  background: #ffffff;
  border: 1px solid rgba(46, 66, 93, 0.08);
  box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1);
  border-radius: 4px;
}
.rc-res-left-card-boxes {
  width: 14px;
  height: 14px;
  border-radius: 2px;
}
.bg-boxred {
  background: #ec0d06;
}
.bg-boxgreen {
  background: #2aa869;
}
.bg-boxorange {
  background: #ef9727;
}
.bg-boxyellow {
  background: #f9c82b;
}
.rc-reviewtag {
  padding: 2px 10px;
  background: rgba(255, 224, 116, 0.29);
  border-radius: 20px;
  color: #cd8428;
}
.rc-result-right-top {
  padding: 16px;
  background: linear-gradient(0deg, #2e425d, #2e425d), #ffffff;
  border-radius: 12px;
}
.color-ad1927 {
  color: #ad1927;
}
.rc-rrt-subbars {
  padding: 0px 16px;
  background: rgba(255, 255, 255, 0.35);
  border-radius: 4px;
  color: #1a4164;
}
.rc-suggested-tags {
  padding: 8px 12px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  box-shadow: 0px 0px 4px rgba(0, 255, 255, 0.4);
  backdrop-filter: blur(10.8126px);
  border-radius: 20px;
}
.joblistingcards .card {
  width: 256px;
  background: rgba(82, 166, 255, 0.08);
  border-radius: 8px;
  flex-shrink: 0;
}
.joblistingcards .card-body {
  padding: 10px;
}
.joblistingcard-tags {
  padding: 0 8px;
  background: #376faa;
  border-radius: 4px;
}
.accordioncards .card {
  background: #ffffff;
  box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1);
  border-radius: 8px;
}
.accordioncards .card-header {
  padding: 10px;
  height: 52px;
  background: #ffffff;
  /* box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1); */
  border-radius: 8px 8px 0px 0;
  border-bottom: 1px solid #d2e0eb;
  margin: 0 3px;
}
.accordioncards .card-body {
  padding: 10px;
  background: #ffffff;
  box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1);
  border-radius: 0 0px 10px 10px;
}
.fairtag {
  padding: 2px 15px;
  background: rgba(215, 52, 44, 0.1);
  border-radius: 20px;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: #d7342c;
}
.okaytag {
  padding: 2px 15px;
  background: rgba(249, 179, 132, 0.45);
  border-radius: 20px;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: #f47529;
}
.goodtag {
  padding: 2px 15px;
  background: rgba(255, 221, 128, 0.45);
  border-radius: 20px;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: #ef9727;
}
.amzngtag {
  padding: 2px 15px;
  background: #e6f4e6;
  border-radius: 20px;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: #038e00;
}
.parsedtagsize {
  width: 100px;
  text-align: center;
}
.questionmarktag {
  padding: 2px 25px;
  background: #dadada;
  border-radius: 20px;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: #8c8c8c;
}
.fileinputcontainer {
  padding: 5px 16px;
  background: rgba(32, 99, 155, 0.2);
  border-radius: 8px;
}

/* Slide Left (For Load Less) */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.2s ease-in-out;
}
.slide-left-enter {
  opacity: 0;
  transform: translateX(-100%);
}
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

/* Slide Right (For Load More) */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.2s ease-in-out;
}
.slide-right-enter {
  opacity: 0;
  transform: translateX(100%);
}
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.template3-height {
  height: calc(100vh - 295px);
}
#resumeclinicmodal .modal-body {
  padding: 0;
}
@media (min-width: 1200px) {
  #resumeclinicmodal .modal-xl {
    max-width: 1200px;
  }
}
@media (min-width: 600px) and (max-width: 1028px) {
  .template-height {
    height: unset !important;
  }
  .mob-mt30px {
    margin-top: 30px;
  }
  .template3-height {
    height: calc(100vh - 317px) !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .tabh-unset {
    height: unset !important;
  }
}
@media (max-width: 600px) {
  #resumeclinicmodal___BV_modal_outer_ {
    z-index: 1040 !important;
  }

  #resumeclinicmodal .modal-body {
    padding: 0;
    background: #f7f9fc;
  }
  .template-height {
    height: calc(100vh - 194px) !important;
    overflow: auto;
  }
  .mob-justify-unset {
    justify-content: unset !important;
  }
  .mob-mt30px {
    margin-top: 30px;
  }
  .mobflexrow {
    flex-direction: row !important;
  }
  #resumeclinicmodal .modal-content {
    border-radius: 0;
  }
  .mobpl2 {
    padding-left: 0.5rem !important;
  }
  .unlockbtn {
    left: 25% !important;
    top: 30% !important;
  }
  .color-376FAA {
    color: #376faa;
  }
  .joblistingcards .card-body {
    padding: 10px 10px 10px 10px;
  }
  .mobilecloseicon {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
.unlockbtn {
  left: 43%;
  top: 20%;
}
.amzing-dial {
  left: 52px;
  bottom: 5px;
  transform: rotate(170deg);
}
.good-dial {
  bottom: 7px;
  left: 40px;
  transform: rotate(115deg);
}
.okay-dial {
  bottom: 6px;
  left: 34px;
  transform: rotate(60deg);
}
.fair-dial {
  bottom: 6px;
  left: 30px;
}
.color-263238 {
  color: #263238;
}
.blurbackground .card-text {
  background: rgba(240, 244, 248, 0.4);
  filter: blur(5px);
}
.unlockbtn .btn {
  height: 35px;
}
.noborder {
  border: unset !important;
  display: none;
}
.template-height {
  height: calc(100vh - 300px);
}
.opacityblackarw {
  opacity: 0.5;
}
.uplod-error-box {
  border: 2px dashed #cb3d00;
  box-shadow: 0px 11.6745px 14.0094px -2.33491px rgba(16, 24, 40, 0.1),
    0px 4.66981px 4.66981px -2.33491px rgba(16, 24, 40, 0.04);
  border-radius: 7.00472px;
}
.hp-course-horizontal-scroll::-webkit-scrollbar {
  scroll-behavior: smooth;
  width: 0px !important;
  height: 0px !important;
  background-color: transparent !important;
}
.slider {
  -webkit-appearance: none;
  /* Remove default styling in WebKit browsers */
  width: 120px;
  height: 6px;
  background: #f0f0f5;
  border-radius: 8px;
  outline: none;
  transition: opacity 0.2s;
  display: flex;
  justify-content: center;
  margin: auto;
  align-items: center;
  margin-top: 15px;
}

.slider:hover {
  opacity: 1;
  /* Full opacity on hover */
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 6px;
  background: #4A7EFF;
  cursor: pointer;
  border-radius: 8px;
}
.rc-compare-container .custom-control-label::before,
.rc-compare-container .custom-switch .custom-control-label::after {
  cursor: pointer;
}
.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #d9d9d9 !important;
}

.bs-tooltip-top .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #d9d9d9 !important;
}

.tooltip-inner {
  max-width: 200px;
  color: #3a3c40 !important;
  text-align: center;
  background-color: #d9d9d9 !important;
  border-radius: 8px !important;
}
.joblistingcards::-webkit-scrollbar {
  scroll-behavior: smooth !important;
  width: 0px !important;
  height: 0px !important;
  background-color: transparent !important;
}
.uploaded-green-border {
  border: 3px solid #039855;
  box-shadow: 0px 11.6745px 14.0094px -2.33491px rgba(16, 24, 40, 0.1),
    0px 4.66981px 4.66981px -2.33491px rgba(16, 24, 40, 0.04);
  border-radius: 7.00472px;
}
.rs-d-none {
  display: none;
}
.rc-ref-jobscontainer {
  height: 100px;
  position: relative;
  overflow-y: scroll;
}

/* Scoped overrides for Resume Clinic buttons to match candidate project */
#resumeclinicmodal .primary-bluebtn .btn-primary {
  background-color: #4A7EFF !important;
  border-color: #4A7EFF !important;
  border-radius: 50px !important;
  color: #fff !important;
  transform: none !important;
  box-shadow: none !important;
}

#resumeclinicmodal .primary-bluebtn .btn-primary:hover,
#resumeclinicmodal
  .primary-bluebtn
  .btn-primary:not(:disabled):not(.disabled):active,
#resumeclinicmodal
  .primary-bluebtn
  .btn-primary:not(:disabled):not(.disabled).active,
#resumeclinicmodal .primary-bluebtn .show > .btn-primary.dropdown-toggle,
#resumeclinicmodal .primary-bluebtn .btn-primary:not(:disabled):hover {
  background-color: #4A7EFF !important;
  border-color: #4A7EFF !important;
  color: #fff !important;
  transform: none !important;
  box-shadow: none !important;
}

#resumeclinicmodal .primary-bluebtn .btn-primary:disabled,
#resumeclinicmodal .primary-bluebtn .btn-primary:disabled:hover,
#resumeclinicmodal .primary-bluebtn .btn-primary:disabled:focus,
#resumeclinicmodal .primary-bluebtn .btn-primary:disabled:active {
  background-color: #4A7EFF !important;
  color: #fff !important;
  opacity: 0.6 !important;
  transform: none !important;
  box-shadow: none !important;
}

#resumeclinicmodal .builder-outline-btns .btn-outline-secondary {
  border-radius: 50px !important;
}
</style>
